export default __webpack_public_path__ + "locales/pt/ConvertPasswordDialog.json?hash=315eac2285cae2e9ad9b7066eb9ef948";